import type { ILinkSeriesTheme } from '../../../../series/link/interface';

export const link: ILinkSeriesTheme = {
  arrow: {
    style: {
      size: 10
    }
  }
};
